import { render, staticRenderFns } from "./phone-number-box.vue?vue&type=template&id=ace85c8e&"
import script from "./phone-number-box.vue?vue&type=script&lang=ts&"
export * from "./phone-number-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports